// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"750f881a","455":"5e6ad744","977":"ce611e2e"}[chunkId] + ".chunk.js";
};